import type { UtilisationGranularity } from '@timelog/pm-shared';

/**
 * Pixel geometry of the resource planner grid.
 *
 * These are STRUCTURAL constants, not spacing: cell widths carry the period
 * columns, the frozen pane carries four fixed sub-columns. Do not snap them to
 * the 8pt grid — same rule as `planning/timeline/timelineGeometry.ts`.
 */

export const PLANNER_ROW_HEIGHT_PX = 40;
export const PLANNER_HEADER_HEIGHT_PX = 48;

/** The frozen left pane and its sub-columns (240 + 92 + 84 + 84 = 500). */
export const LEFT_PANE_WIDTH_PX = 500;
export const NAME_COL_PX = 240;
export const UTIL_COL_PX = 92;
export const NUM_COL_PX = 84;

/** Period column width per scale — wide enough for a 4-digit value + unit. */
export const CELL_WIDTH_BY_SCALE: Record<UtilisationGranularity, number> = {
  day: 28,
  week: 52,
  month: 66,
  quarter: 152,
};

/** Indent per row depth in the name column. */
export const PLANNER_INDENT_PX = 18;

/** The utilisation mini-bar inside the Utilisation column. */
export const UTIL_BAR_WIDTH_PX = 46;
